var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileListLine3 = function SvgFileListLine3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.8 21H6.2a2.7 2.7 0 0 1-2.7-2.7V3.9a.9.9 0 0 1 .9-.9H17a.9.9 0 0 1 .9.9v10.8h3.6v3.6a2.7 2.7 0 0 1-2.7 2.7m-.9-4.5v1.8a.9.9 0 1 0 1.8 0v-1.8zm-1.8 2.7V4.8H5.3v13.5a.9.9 0 0 0 .9.9zm-9-11.7h7.2v1.8H7.1zm0 3.6h7.2v1.8H7.1zm0 3.6h4.5v1.8H7.1z"
  })));
};
export default SvgFileListLine3;